export const questions = [
  /* 1 */
  {
    id: "picnic",
    title:
      "YOU ARE GOING ON A PICNIC, WHICH THREE OF THE FOLLOWING ITEMS ARE YOU BRINGING?",
    max: 3,
    options: [
      "CHIPS & DIPS","PASTRIES","BEER","FRUIT","HOMEMADE PIZZA","MATCHA",
      "BOOKS","PACK OF CARDS","THE VIBES","BLANKETS","CAMERA","SPEAKER","WINE"
    ],
  },

  /* 2 */
  {
    id: "zine",
    title: "YOUR LIFE JUST BECAME A ZINE — WHAT’S THE COVER?",
    max: 1,
    options: [
      "TORN COLLAGE","FLASH PHOTO","HANDDRAWN","MINIMALIST","TYPEWRITER FONT",
      "CLOSE-UP","BLACK INK","STICKER BOMB","ACTION SHOT","MIRROR SELFIE"
    ],
  },

  /* 3 — прежний id оставляем → бэкенду ничего менять не надо */
  {
    id: "weather",
    title: "WHICH TYPE OF WEATHER HITS THE HARDEST?",
    max: 2,
    options: [
      "FROSTY MORNINGS","BURNING SUN","GENTLE BREEZE","THUNDERSTORM","GOLDEN HOUR",
      "HAILING","CYCLONE","SNOW-DAYS","BLUE SKIES","TORNADO ALLEY"
    ],
  },

  /* 4 — новая «вос-пауза-вайб» секция */
  {
    id: "slowdown",                // любое уникальное id
    title: "WHAT’S YOUR VIBE WHEN THE WORLD SLOWS DOWN?",
    max: 2,
    options: [
      "CIGARETTES OUT OF THE WINDOW",
      "STATIC ON THE TV",
      "FRESH LAUNDRY",
      "\"PASTA, NO RECIPE\"",
      "THE SUN",
      "DANCE LIKE NO ONE’S WATCHING",
      "TAKE THE LONG WAY HOME",
      "NO NOTIFS",
    ],
  },

  /* 5 */
  {
    id: "genre",
    title: "WHICH GENRE DEFINES YOUR PERSONALITY THE MOST?",
    max: 1,
    options: [
      "POP","ROCK","DANCE","DISCO","INDIE","EMO","JAZZ","R&B/SOUL",
      "HOUSE","COUNTRY","FOLK","ALTERNATIVE","ELECTRONIC","CLASSICAL"
    ],
  },

  /* 6 */
  {
    id: "mood",
    title: "HOW DO YOU FEEL IN THIS VERY MOMENT?",
    max: 2,
    options: [
      "DREAMY","PLAYFUL","ENERGISED","NOSTALGIC","THOUGHTFUL","WILD & FREE",
      "CONFIDENT","INSPIRED","IN-LOVE","MELANCHOLIC","CALM","COZY","FUNKY","SLEEPY"
    ],
  },

  /* 7 */
  {
    id: "extra",
    type: "textarea",
    title: "ANYTHING ELSE WE SHOULD KNOW?",
    placeholder: "Think about decades, artists, languages you relate to…",
    narrow: true          // <‑‑ добавили
  },
  
];
